var exports = {
  "k": "xe564cbfb--8e157b--container",
};

module.exports = exports;
